/** Métodos de recebimento extras configurados por unidade (ex.: PIX Banco X). */
export type ClinicCustomPaymentMethod = {
  id: string;
  label: string;
  active?: boolean;
};

const STANDARD_LABELS_LOWER = new Set([
  'dinheiro', 'pix', 'cartão de crédito', 'cartao de credito', 'cartão de débito', 'cartao de debito',
  'crédito - link de pagamento', 'credito - link de pagamento', 'boleto', 'transferência', 'transferencia',
  'convênio / plano', 'convenio / plano', 'convênio', 'convenio', 'cheque',
]);

export function isReservedReceivablePaymentLabel(label: string): boolean {
  const t = label.trim().toLowerCase();
  return !t || STANDARD_LABELS_LOWER.has(t);
}

export function customMethodSelectValue(label: string): string {
  return label.trim();
}

export function customMethodsToSelectOptions(
  customs: ClinicCustomPaymentMethod[],
): { value: string; label: string; isCustom?: boolean }[] {
  return (customs || [])
    .filter((m) => m.active !== false && m.label?.trim())
    .map((m) => ({
      value: customMethodSelectValue(m.label),
      label: m.label.trim(),
      isCustom: true,
    }));
}

let customLabelByValue: Record<string, string> = {};

/** Atualiza mapa global para labels em listagens (painel, relatórios no front). */
export function setCustomReceivablePaymentMethodLabels(customs: ClinicCustomPaymentMethod[]) {
  customLabelByValue = {};
  for (const m of customs || []) {
    if (m.active === false || !m.label?.trim()) continue;
    const v = customMethodSelectValue(m.label);
    customLabelByValue[v] = m.label.trim();
    if (m.id) customLabelByValue[m.id] = m.label.trim();
  }
}

export function getCustomReceivablePaymentLabel(value: string | null | undefined): string | null {
  if (!value) return null;
  const key = String(value).trim();
  return customLabelByValue[key] || null;
}

export function parseCustomReceivablePaymentMethods(raw: unknown): ClinicCustomPaymentMethod[] {
  if (!Array.isArray(raw)) return [];
  const seen = new Set<string>();
  const out: ClinicCustomPaymentMethod[] = [];
  for (const item of raw) {
    const label = String((item as any)?.label || '').trim().slice(0, 120);
    if (!label || isReservedReceivablePaymentLabel(label)) continue;
    const key = label.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    const id = String((item as any)?.id || '').trim() || `cm_${key.replace(/[^a-z0-9]+/g, '_').slice(0, 40)}`;
    out.push({
      id,
      label,
      active: (item as any)?.active !== false,
    });
  }
  return out;
}

export function newCustomReceivablePaymentMethod(label = ''): ClinicCustomPaymentMethod {
  return {
    id: typeof crypto !== 'undefined' && crypto.randomUUID
      ? crypto.randomUUID()
      : `cm_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`,
    label,
    active: true,
  };
}
